import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";

import moment from "moment";
import { toast } from "react-toastify";

import { dateConversion } from "../../../components/Validation";

const SalaryCalculationForm = (props) => {
  const frmRef = useRef({});
  const [activeSalaryHeadList, setActiveSalaryHeadList] = useState([]);
  const [wareHouseData, setWareHouseData] = useState([]);
  const [financialYearData, setFinancialYearData] = useState([]);
  const [departmentData, setDepartmentData] = useState([]);
  const [designationData, setDesignationData] = useState([]);
  const [fyMonthData, setFyMonthData] = useState([]);
  const [daysData, setDaysData] = useState([]);
  const [monthId, setMonthId] = useState(0);
  const [yearNo, setYearNo] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [labourData, setLabourData] = useState([]);
  const [warehouseId, setWarehouseId] = useState(0);
  const [financialYearId, setFinancialYearId] = useState(0);

  const [dateFormat, setDateFormat] = useState(
    localStorage.getItem("dateFormat")
  );

  const [empType, setEmpType] = useState("Employee");
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );
  const [selectedFromDate, setSelectedFromDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const [selectedToDate, setSelectedToDate] = useState(
    new Date().toISOString().substr(0, 10)
  );
  const currentDate = new Date().toISOString().slice(0, 10);

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };
  const handleFromDateChange = (e) => {
    setSelectedFromDate(e.target.value);
  };

  const handleToDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  const { sendRequest: getWarehouseData } = useHttp();
  const getWarehouseDetail = () => {
    getWarehouseData(
      {
        // url: "/api/warehouses/",
        url: `/api/warehouses/?orgId=${localStorage.getItem("orgId")}&&storeTypeId=1&&createdBy=${localStorage.getItem("id")}`,
      },
      (res) => {
        if (res) {
          // //console.log(res);
          setWareHouseData(res);
        }
      }
    );
  };

  useEffect(() => {
    getWarehouseDetail();
  }, [getWarehouseData]);

  const { sendRequest: getfinancialYear } = useHttp();
  const FillFinancialYear = () => {
    getfinancialYear(
      {
        url: `/api/financialYear/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          // //console.log(res);
          setFinancialYearData(res);
        }
      }
    );
  };

  useEffect(() => {
    FillFinancialYear();
  }, [getfinancialYear]);

  useEffect(() => {
    getWarehouseDetail();
  }, [getWarehouseData]);

  const { sendRequest: getDepartment } = useHttp();
  const fillDepartment = () => {
    getDepartment(
      {
        url: `/api/department/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          // //console.log(res);
          setDepartmentData(res);
        }
      }
    );
  };

  useEffect(() => {
    fillDepartment();
  }, [getDepartment]);

  const { sendRequest: getDesignation } = useHttp();
  const FillDesignation = () => {
    getDesignation(
      {
        url: `/api/designation/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          // //console.log(res);
          setDesignationData(res);
        }
      }
    );
  };

  useEffect(() => {
    FillDesignation();
  }, [getDesignation]);

  const { sendRequest: getActiveSalaryHead } = useHttp();
  const FillActiveSalaryHead = () => {
    getActiveSalaryHead(
      {
        url: `/api/getActiveSalaryHead/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          //  //console.log(res);
          setActiveSalaryHeadList(res);
        }
      }
    );
  };

  useEffect(() => {
    FillActiveSalaryHead();
  }, [getActiveSalaryHead]);

  const calculateTemplate = (empData, mainIndex) => {
    // //console.log("calculateTemplate");
    // //console.log(empData);
    var salaryTemplateDetails = empData[mainIndex].salaryTemplateDetails;

    var totalPayout = 0;
    salaryTemplateDetails.forEach((element) => {
      // //console.log("element.amount", element.salaryHeadAmount);
      if (element.calculationType == "Add") {
        totalPayout = totalPayout + parseFloat(element.salaryHeadAmount ?? 0);
      } else {
        totalPayout = totalPayout - parseFloat(element.salaryHeadAmount);
      }
    });
    // //console.log(totalPayout);
    empData[mainIndex].inhandSalary = totalPayout;
    setEmployeeData([...empData]);
  };

  const fillMonth = (fyId) => {
    var fyList = financialYearData.filter(
      (item) => item.financialYearId == fyId
    );

    if (fyList && fyList.length > 0) {
      var fyyear = fyList && fyList[0];
      //console.log("fyyear", fyyear);

      var fromDate = dateConversion(
        fyyear.financialYearStartDate,
        dateFormat,
        "YYYY/MM/DD"
      );
      var endDate = dateConversion(
        fyyear.financialYearEndDate,
        dateFormat,
        "YYYY/MM/DD"
      );

      var fDate = new Date(fromDate);
      var tDate = new Date(endDate);

      var fmonth = 0;
      var fyear = 0;
      var tmonth = tDate.getMonth() + 1;
      var tyear = tDate.getFullYear();
      var conterDate = fDate;
      var newList = [];
      var counter = 0;
      do {
        var fmonth = conterDate.getMonth() + 1;
        var fyear = conterDate.getFullYear();
        var month = conterDate.toLocaleString("default", { month: "long" });
        newList = newList.concat({
          monthId: fmonth,
          yearId: fyear,
          strtext: month + " " + fyear,
          value: fmonth + "," + fyear,
        });

        if (fmonth == 12) {
          fyear++;
          fmonth = 1;
        } else {
          fmonth++;
        }
        conterDate = new Date(
          fyear.toString() + "/" + fmonth.toString() + "/1"
        );

        counter++;
      } while (counter < 12);

      setFyMonthData(newList);
      //console.log("newList", newList);
    }
  };

  const fillDaysMonth = () => {
    var fDate = new Date(frmRef.current.fromDate.value);
    var tDate = new Date(frmRef.current.toDate.value);

    const diffTime = Math.abs(tDate - fDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;

    var conterDate = fDate;
    var newList = [];
    var counter = 0;

    do {
      var fmonth = conterDate.getMonth() + 1;
      var fday = conterDate.getDay() + 1;
      var dd = conterDate.getDate();
      newList = newList.concat({
        monthId: fmonth,
        day: fday,
        strtext: dd + "/" + fmonth,
        value: dd + "," + fmonth,
      });

      // if(fmonth==12)
      // {
      //   fyear++;
      //   fmonth=1;
      // }
      // else
      // {
      //   fmonth++;
      // }
      // conterDate= new Date(fyear.toString() +"/"+fmonth.toString()+"/1")

      counter = counter + 1;
      conterDate.setDate(conterDate.getDate() + 1);
      var dd = conterDate.getDate();
      //console.log("conterDate getDate", dd);
    } while (counter < diffDays);

    setDaysData(newList);
    //console.log("newList", newList);
  };

  const { sendRequest: getLabourDataData } = useHttp();
  const FillLabourData = (wId, _fromdate, _todate) => {
    if (wId > 0) {
      try {
        getLabourDataData(
          {
            url: `/api/getLabourForSalaryCalculation/?orgId=${localStorage.getItem(
              "orgId"
            )}&&warehouseId=${wId}&&fromDate=${_fromdate}&&toDate=${_todate}`,
          },
          (res) => {
            if (res) {
              //console.log(res);
              //console.log("getLabourDataData", res);

              var updatedEmp = res.map((employee) => ({
                ...employee,
                createdBy: parseInt(localStorage.getItem("id")),

                status: 1,
                orgId: localStorage.getItem("orgId"),
              }));

              updatedEmp.forEach((element) => {
                element.totalDays = daysData.length;
              });
              //console.log("updatedEmp", updatedEmp);
              setLabourData(updatedEmp);
            }
          }
        );
      } catch (error) {
        //console.log("error", error);
        console.error(error); // You might send an exception to your error tracker like AppSignal
        return error;
      }
    } else {
      setLabourData([]);
    }
  };

  useEffect(() => {
    FillLabourData(0);
  }, [getLabourDataData]);

  const { sendRequest: getemployeeData } = useHttp();
  const FillEmployeeData = (wId, _monthId, _yearNo) => {
    //console.log("wId", wId);
    //console.log("_monthId", _monthId);
    //console.log("_yearNo", _yearNo);

    if (wId > 0 && _monthId > 0 && _yearNo > 0) {
      try {
        getemployeeData(
          {
            url: `/api/getEmployeeForSalaryCalculation/?orgId=${localStorage.getItem(
              "orgId"
            )}&&warehouseId=${wId}&&financialYearId=${financialYearId}&&monthId=${_monthId}&&yearNo=${_yearNo}`,
          },
          (res) => {
            if (res) {
              //console.log(res);
              // setEmployeeData(res);
              const updatedEmp = res.map((employee) => ({
                ...employee,
                createdBy: parseInt(localStorage.getItem("id")),
                status: 1,
                orgId: localStorage.getItem("orgId"),
              }));

              setEmployeeData(updatedEmp);
            }
          }
        );
      } catch (error) {
        //console.log("error", error);
        console.error(error); // You might send an exception to your error tracker like AppSignal
        return error;
      }
    } else {
      setEmployeeData([]);
    }
  };

  useEffect(() => {
    FillEmployeeData(0);
  }, [getemployeeData]);

  const handledropdownlistChange = (e, index) => {
    const value = e.target.value;
    employeeData[index].attendanceType = e.target.value;
    var newstr = employeeData;
    setEmployeeData([...employeeData]);
  };

  const handledDDLShiftChange = (e, index) => {
    const value = e.target.value;
    employeeData[index].shiftId = parseInt(e.target.value);
    var newstr = employeeData;
    setEmployeeData([...employeeData]);
  };

  const calculateTotalHours = (employee) => {
    const fromTime = moment(employee.inTime, "HH:mm");
    const toTime = moment(employee.outTime, "HH:mm");
    const overTime = parseFloat(employee.overTime) || 0;

    let totalHours;
    if (fromTime.isBefore(toTime)) {
      totalHours = toTime.diff(fromTime, "hours", true) + overTime;
    } else {
      totalHours = fromTime.diff(toTime, "hours", true) - overTime;
    }

    return totalHours.toFixed(2);
  };

  const handleTimeFieldChange = (e, index) => {
    const fieldName = e.target.id;
    const value = e.target.value;

    //console.log(e.target.value);

    employeeData[index][fieldName] = value;

    const totalHours = calculateTotalHours(employeeData[index]);
    employeeData[index].totalHrs = totalHours;

    setEmployeeData([...employeeData]);
  };

  const { sendRequest: postEmployeeAttendance } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();
    //console.log("employeeData", employeeData);

    var sdate = moment(frmRef.current.date.value).format("DD/MM/YYYY");
    var monthText = "";

    var mlist = fyMonthData.filter(
      (item) => item.value == monthId + "," + yearNo
    );
    if (mlist && mlist.length > 0) {
      monthText = mlist[0].strtext;
    }
    var iCounter = 0;
    employeeData.forEach((element) => {
      // //console.log(seffectiveFrom,oldeffectiveFrom)
      // if(seffectiveFrom!=oldeffectiveFrom)
      // {
      //   //  delete employeeData[iCounter]["salaryTemplateId"];
      //    var salaryTemplateDetails=employeeData[iCounter].salaryTemplateDetails;
      //    var kCounter=0
      //    salaryTemplateDetails.forEach(element =>
      //     {
      //     delete salaryTemplateDetails[kCounter]["salaryTemplateDetailId"];
      //     delete salaryTemplateDetails[kCounter]["salaryTemplateId"];

      //     kCounter++;
      //   });
      //   //console.log(salaryTemplateDetails)
      //   employeeData[iCounter].salaryTemplateDetails=salaryTemplateDetails;
      // }
      // employeeData[iCounter].salaryTemplateName=element["employeeName"]+" "+element["employeeCode"]+" " +seffectiveFrom;
      // employeeData[iCounter].effectiveFrom=seffectiveFrom;
      employeeData[iCounter].salaryCalculationDate = sdate;
      employeeData[iCounter].monthText = monthText;
      employeeData[iCounter].orgId = localStorage.getItem("orgId");
      employeeData[iCounter].status = 1;
      employeeData[iCounter].createdBy = localStorage.getItem("userId");

      iCounter++;
    });

    //console.log("employeeData", employeeData);

    postEmployeeAttendance(
      {
        url: "/api/salaryCalculation/",
        method: "POST",
        body: employeeData,
      },
      (data) => {
        //console.log(data);
        toast.success("Employee salary calculated successfully");
       props.addForm(false);
      },(error)=>{
        console.log(error)
      }
    );
  };
  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            &nbsp;
            <div className="card card-default">
              <form onSubmit={submitHandler} >
                {/* onSubmit={submitHandler} */}
                <div className="card-header">
                  <h3 className="card-title">Salary Calculation Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-2">
                      <label htmlFor={"Date"}>{"Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"warehouse"}>{"WareHouse"}</label>

                      <select
                        className="form-control"
                        id={"warehouse"}
                        // ref={(el) => (frmRef.current["warehouse"] = el)}
                        required
                        onChange={(e) => {
                          //console.log("warehosue", e.target.value);
                          var wId = 0;
                          if (e.target.value != "Select") wId = e.target.value;
                          setWarehouseId(wId);
                        }}
                      >
                        <option value="">Select</option>
                        {wareHouseData &&
                          wareHouseData.map((x) => (
                            <option key={x.id} value={x.id}>
                              {x.name}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"FinancialYear"} className="headerlabel">
                        {"Financial Year"}
                      </label>

                      <select
                        className="form-control"
                        id={"warehouse"}
                        // ref={(el) => (frmRef.current["warehouse"] = el)}
                        required
                        onChange={(e) => {
                          //console.log("Financial Year", e.target.value);
                          fillMonth(e.target.value);
                          var fyId = 0;
                          if (
                            e.target.value != "Select" &&
                            e.target.value != ""
                          )
                            fyId = e.target.value;

                          setFinancialYearId(fyId);
                        }}
                      >
                        <option value="">Select</option>
                        {financialYearData &&
                          financialYearData.map((x) => (
                            <option
                              key={x.financialYearId}
                              value={x.financialYearId}
                            >
                              {x.financialYearName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-2">
                      <label htmlFor={"employee_type"}>{"Employee Type"}</label>

                      <select
                        id="employee_type"
                        className="form-control"
                        ref={(el) => (frmRef.current["employee_type"] = el)}
                        required
                        onChange={(e) => {
                          if (e.target.value != "Select")
                            setEmpType(e.target.value);
                        }}
                      >
                        <option value="">Select</option>
                        <option>Labour </option>
                        <option>Employee </option>
                      </select>
                    </div>
                  </div>
                  <br />
                  <div className="row">
                    <div className="col-md-2">
                      <label htmlFor={"Month"}>{"Month"}</label>
                      <select
                        className="form-control"
                        id={"department"}
                        ref={(el) => (frmRef.current["month"] = el)}
                        required
                        onChange={(e) => {
                          if (e.target.value != "") {
                            var _value = e.target.value;
                            var darray = _value.split(",");
                            setMonthId(darray[0]);
                            setYearNo(darray[1]);
                            FillEmployeeData(warehouseId, darray[0], darray[1]);
                          }
                        }}
                      >
                        <option value="">Select</option>
                        {fyMonthData &&
                          fyMonthData.map((x) => (
                            <option key={x.value} value={x.value}>
                              {x.strtext}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-2">
                      {empType == "Labour" ? (
                        <label htmlFor={"Month"}>{"From Date"}</label>
                      ) : (
                        ""
                      )}
                      {empType == "Labour" ? (
                        <input
                          type={"date"}
                          id={"fromDate"}
                          required
                          ref={(el) => (frmRef.current["fromDate"] = el)}
                          className="form-control"
                          max={currentDate}
                          value={selectedFromDate}
                          onChange={handleFromDateChange}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="col-md-2">
                      {empType == "Labour" ? (
                        <label htmlFor={"Month"}>{"To Date"}</label>
                      ) : (
                        ""
                      )}
                      {empType == "Labour" ? (
                        <input
                          type={"date"}
                          id={"toDate"}
                          required
                          ref={(el) => (frmRef.current["toDate"] = el)}
                          className="form-control"
                          max={currentDate}
                          value={selectedToDate}
                          onChange={handleToDateChange}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="text-center">
                    <div className="mt-3">
                      <button
                        className="btn btn-sm btn-secondary"
                        type="submit"
                        onClick={(e) => {
                          e.preventDefault();

                          if (empType == "Labour") {
                            var fDate = moment(
                              frmRef.current.fromDate.value
                            ).format("DD/MM/YYYY");
                            var tDate = moment(
                              frmRef.current.toDate.value
                            ).format("DD/MM/YYYY");
                            fillDaysMonth();
                            FillLabourData(warehouseId, fDate, tDate);
                          } else {
                            FillEmployeeData(warehouseId, monthId, yearNo);
                          }
                        }}
                      >
                        Get Data
                      </button>
                    </div>
                  </div>
                  
                  <div className="row">
                    {empType == "Labour" ? (
                      <table className="table table-bordered table-sm text-center">
                        <tr className="">
                          <th>Labour Name</th>
                          <th>Labour Code</th>
                          <th>Total Days </th>
                          <th>Per day Wages</th>
                          <th>Total Present Days </th>
                          <th>Final Payout</th>
                        </tr>

                        <tbody>
                          {labourData &&
                            labourData.map((itm, i) => {
                              return (
                                <tr key={i} className="tablerowview">
                                  <td> {itm.employeeName}</td>
                                  <td>{itm.employeeCode} </td>
                                  <td>{itm.totalDays} </td>

                                  <td>{itm.perDayWages} </td>

                                  <td>{itm.totalPresent} </td>
                                  <td>{itm.inhandSalary} </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    ) : (
                      <table className="table table-bordered table-sm text-center">
                        <tr className="">
                          <th>Employee Name</th>
                          <th>Employee Code</th>
                          <th>Total Days </th>

                          <th>Unpaid Leave </th>
                          <th>Total Present Days </th>
                          <th>Gross Salary</th>
                          {activeSalaryHeadList.map((headItem, index) => (
                            <React.Fragment key={index}>
                              <th>{headItem.salaryHeadName}</th>
                            </React.Fragment>
                          ))}

                          <th>Leave Deduction Amount </th>
                          <th>Final Payout</th>
                        </tr>

                        <tbody>
                          {employeeData &&
                            employeeData.map((itm, i) => {
                              return (
                                <tr key={i} className="tablerowview">
                                  <td> {itm.employeeName}</td>
                                  <td>{itm.employeeCode} </td>
                                  <td>{itm.totalDays} </td>

                                  <td>{itm.totalUnpaidleaves} </td>
                                  <td>{itm.totalPresentDays} </td>

                                  <td>{itm.grossSalary} </td>

                                  {itm.salaryCalculationDetails.map(
                                    (headItem, index) => (
                                      <React.Fragment key={index}>
                                        <td>{headItem.salaryHeadAmount} </td>
                                      </React.Fragment>
                                    )
                                  )}

                                  <td>{itm.unpaidLeaveAmount}</td>
                                  <td>{itm.finalPayoutSalary}</td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    )}

                    <br />
                  </div>
                  <div className="text-center">
                    <button className="btn btn-primary" type="submit">
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default SalaryCalculationForm;
